import { IOfferDescriptionVisualParameter } from "./IOfferDescriptionVisualParameter";

import { IPrivateOfferModel } from "../../offerQuestConditions/IPrivateOfferModel";

export class BasicOfferDescriptionVisualFactory {
    protected modelData: IPrivateOfferModel;

    constructor(model: IPrivateOfferModel) {
        this.modelData = model;
    }

    public createOfferDescriptionVisualObject(name: string, params: any): IOfferDescriptionVisualParameter {
        let finalProduct: IOfferDescriptionVisualParameter;

        return finalProduct;
    }

    public dispose(): void {
        this.modelData = null;
    }
}

